import styled from 'styled-components'

export const BuildingDetailsContainer = styled.div`
  margin: 0 auto;
`

export const BuildingContentContainer = styled.div`
  padding: 0 ${({ theme }) => theme.spacing.large}
    ${({ theme }) => theme.spacing.large};

  @media (max-width: 768px) {
    padding: ${({ theme }) => theme.spacing.medium};
  }
`

export const SummaryBar = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.medium};
  align-items: center;
  background: ${({ theme }) => theme.colors.background.primary};
  padding: ${({ theme }) => theme.spacing.medium}
    ${({ theme }) => theme.spacing.large};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.secondary};
  flex-wrap: wrap;
  margin-bottom: ${({ theme }) => theme.spacing.large};
`

export const SummaryBarItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};

  strong {
    color: ${({ theme }) => theme.colors.text.primary};
  }
`

export const SummaryBarDivider = styled.span`
  width: 1px;
  height: 16px;
  background: ${({ theme }) => theme.colors.border.default};
`

export const SummaryBarDot = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 9px;
  background: ${({ $color }) => $color}14;

  &::after {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ $color }) => $color};
  }
`

export const LegendContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  background: ${({ theme }) => theme.colors.background.secondary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  margin-top: 16px;
`

export const LegendTitle = styled.span`
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors.text.tertiary};
  margin-right: 4px;
`

export const LegendItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const LegendDot = styled.span<{ $color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
  flex-shrink: 0;
`

export const LegendSwatch = styled.span<{ $color: string }>`
  display: inline-block;
  width: 14px;
  height: 8px;
  border-radius: 2px;
  background: ${({ $color }) => $color};
  flex-shrink: 0;
`

export const LegendDivider = styled.span`
  width: 100%;
  height: 1px;
  background: ${({ theme }) => theme.colors.border.default};
`

export const BuildingsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const BuildingCardContainer = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  overflow: hidden;
  transition: ${({ theme }) => theme.transitions.default};

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }

  &.collapsed .building-details {
    display: none;
  }

  &.type-residential {
    background: linear-gradient(
      135deg,
      rgba(0, 173, 230, 0.02) 0%,
      ${({ theme }) => theme.colors.background.primary} 100%
    );
    border-color: rgba(0, 173, 230, 0.15);
  }
  &.type-residential:hover {
    border-color: rgba(0, 173, 230, 0.3);
  }

  &.type-residential-minority {
    background: linear-gradient(
      135deg,
      rgba(255, 122, 0, 0.02) 0%,
      ${({ theme }) => theme.colors.background.primary} 100%
    );
    border-color: rgba(255, 122, 0, 0.15);
  }
  &.type-residential-minority:hover {
    border-color: rgba(255, 122, 0, 0.3);
  }

  &.type-residential-majority {
    background: linear-gradient(
      135deg,
      rgba(0, 122, 166, 0.02) 0%,
      ${({ theme }) => theme.colors.background.primary} 100%
    );
    border-color: rgba(0, 122, 166, 0.15);
  }
  &.type-residential-majority:hover {
    border-color: rgba(0, 122, 166, 0.3);
  }

  &.type-retail {
    background: linear-gradient(
      135deg,
      rgba(255, 149, 0, 0.02) 0%,
      ${({ theme }) => theme.colors.background.primary} 100%
    );
    border-color: rgba(255, 149, 0, 0.15);
  }
  &.type-retail:hover {
    border-color: rgba(255, 149, 0, 0.3);
  }

  &.type-offices {
    background: linear-gradient(
      135deg,
      rgba(123, 97, 255, 0.02) 0%,
      ${({ theme }) => theme.colors.background.primary} 100%
    );
    border-color: rgba(123, 97, 255, 0.15);
  }
  &.type-offices:hover {
    border-color: rgba(123, 97, 255, 0.3);
  }

  &.type-industrial {
    background: linear-gradient(
      135deg,
      rgba(255, 59, 48, 0.02) 0%,
      ${({ theme }) => theme.colors.background.primary} 100%
    );
    border-color: rgba(255, 59, 48, 0.15);
  }
  &.type-industrial:hover {
    border-color: rgba(255, 59, 48, 0.3);
  }

  &.type-public {
    background: linear-gradient(
      135deg,
      rgba(0, 179, 65, 0.02) 0%,
      ${({ theme }) => theme.colors.background.primary} 100%
    );
    border-color: rgba(0, 179, 65, 0.15);
  }
  &.type-public:hover {
    border-color: rgba(0, 179, 65, 0.3);
  }

  &.type-garage {
    background: linear-gradient(
      135deg,
      rgba(0, 170, 184, 0.02) 0%,
      ${({ theme }) => theme.colors.background.primary} 100%
    );
    border-color: rgba(0, 170, 184, 0.15);
  }
  &.type-garage:hover {
    border-color: rgba(0, 170, 184, 0.3);
  }

  &.type-other,
  &.type-not-classified {
    background: linear-gradient(
      135deg,
      rgba(142, 142, 147, 0.02) 0%,
      ${({ theme }) => theme.colors.background.primary} 100%
    );
    border-color: rgba(142, 142, 147, 0.15);
  }
  &.type-other:hover,
  &.type-not-classified:hover {
    border-color: rgba(142, 142, 147, 0.3);
  }
`

export const BuildingHeader = styled.div`
  padding: 16px;
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  transition: background ${({ theme }) => theme.transitions.default};

  &:hover {
    background: ${({ theme }) => theme.colors.background.secondary};
  }
`

export const BuildingIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;

  &.residential {
    background: rgba(0, 173, 230, 0.1);
    color: #00ade6;
  }
  &.residential-minority {
    background: rgba(255, 122, 0, 0.1);
    color: #ff7a00;
  }
  &.residential-majority {
    background: rgba(0, 122, 166, 0.1);
    color: #007aa6;
  }
  &.retail {
    background: rgba(255, 149, 0, 0.1);
    color: #ff9500;
  }
  &.offices {
    background: rgba(123, 97, 255, 0.1);
    color: #7b61ff;
  }
  &.industrial {
    background: rgba(255, 59, 48, 0.1);
    color: #ff3b30;
  }
  &.public {
    background: rgba(0, 179, 65, 0.1);
    color: #00b341;
  }
  &.garage {
    background: rgba(0, 170, 184, 0.1);
    color: #00aab8;
  }
  &.other,
  &.not-classified {
    background: rgba(142, 142, 147, 0.1);
    color: #6b6b6b;
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
  }
`

export const BuildingStatusGroup = styled.div`
  position: absolute;
  bottom: -2px;
  right: -2px;
  display: flex;
  gap: 2px;
`

export const BuildingStatus = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.background.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${({ theme }) => theme.colors.background.primary};
  box-shadow: ${({ theme }) => theme.shadows.sm};

  &.protected {
    color: ${({ theme }) => theme.colors.warning};
  }
  &.underground {
    color: #7b61ff;
  }
  &.under-construction {
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const BuildingInfo = styled.div`
  flex: 1;
  min-width: 0;
`

export const BuildingTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
`

export const BuildingName = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};

  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export const BuildingId = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: 6px;
`

export const BuildingMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 8px;
  }
`

export const MetaItem = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const BuildingPercentage = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;

  &.full {
    background: rgba(0, 179, 65, 0.1);
    color: ${({ theme }) => theme.colors.success};
  }

  &.partial {
    background: rgba(255, 59, 48, 0.1);
    color: ${({ theme }) => theme.colors.danger};
  }
`

export const BuildingActions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const BuildingDetailsSection = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
`

export const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  padding: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px;
  }
`

export const DetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const DetailsTitle = styled.h4`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors.text.tertiary};
  margin: 0 0 4px 0;
`

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding-bottom: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  gap: 8px;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`

export const DetailLabel = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const DetailValue = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
  text-align: right;

  &.highlight {
    color: ${({ theme }) => theme.colors.primary};
  }
`
